Core.PortalCheckoutClinicalJustification = {
  init: function() {
    Core.PortalCheckoutClinicalJustification.handleSubmit();
  },
  handleSubmit: function() {
    var _self = Core.PortalCheckoutClinicalJustification;
    var $form = $('#frmClinicalJustification');
    var $errorWrapper = $form.find('.error-wrapper');
    var $btn = $form.find('.buttonblock button');

    $btn.on('click', function(e) {
      e.preventDefault();
      if (_self.isValid()) {
        $errorWrapper.addClass('d-none');
        $form.submit();
      } else {
        $errorWrapper.removeClass('d-none');
      }
    });
  },
  isValid:function() {
    var $form = $('#frmClinicalJustification');
    var isRequiredValidation = $form.find('#IsRequiredValidation').val();

    if (isRequiredValidation && isRequiredValidation.toLowerCase() === 'true') {
      // check if instructions or attached file is provided
      var hasInstructions = !!$form.find('#clinicalJustificationInstructions').val();
      var hasFiles = $form.find('.fileUpload-fileList input[type=hidden]').length > 0;

      var isValid = hasInstructions || hasFiles;
      return isValid;
    } 
    
    return true;
  }
};
